// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  font-family: 'Open Sans';\n  margin: 0;\n  padding: 0 5%;\n}\n\nh1, h4 {\n  text-align: center;\n}\n\nspan.code,\ndiv.code > p {\n  background: #EAEAEA;\n}\n\nspan.code {\n  padding: 0 8px;\n}\n\ndiv.code {\n  margin: 32px 0;\n  text-align: center;\n}\n\ndiv.code > p {\n  display: inline-block;\n  margin: 0;\n  padding: 8px;\n  text-align: left;\n  white-space: pre;\n}", ""]);
// Exports
module.exports = exports;
